import { gql } from '@apollo/client'

import {
  BOX_ORDER_FRAGMENT,
  NON_CORE_ORDER_FRAGMENT
} from '@/components/pages/Dashboard/components/upcomingBoxes/queries/fragments'

const PRICE_SENSITIVE_PAUSED_PAGE_QUERY = gql`
  ${BOX_ORDER_FRAGMENT}
  ${NON_CORE_ORDER_FRAGMENT}
  query PriceSensitivePausedPageQuery($from: ISO8601Date!, $to: ISO8601Date!) {
    user {
      id
      preferredLanguage
      shippingCountryCode
      ordersByDate(from: $from, to: $to) {
        ...upcomingBoxOrderFragment
        ...nonCoreUpcomingOrderFragment
      }
      subscription {
        id
        status
        activePaymentMethodType
        previewUncreatedFutureBox {
          order {
            id
            deliveryFee
            subtotal
            discountTotalPercentage
          }
        }
        plan {
          id
          durationInWeeks
          pouchSize
          numberOfPouches
          pouchesPerDay
          pricePerWeek
        }
        increasedDeliveryCadencePlan {
          id
          durationInWeeks
          pouchSize
          numberOfPouches
          pouchesPerDay
          pricePerWeek
        }
        currentPause {
          id
          priceSensitiveTreatments
        }
      }
    }
  }
`

export { PRICE_SENSITIVE_PAUSED_PAGE_QUERY }
